import { useNavigate } from "react-router-dom";
import { DISABLE_USER } from "../../apiEndpoints";
import usePatchData from "../../../../CustomHooks/useAxios/usePatchData";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";

function DisableUserDialog({ userID, closeDialog, userName }) {
  const { executePatch, loading, successResponse, formError, setFormError } =
    usePatchData();

  const navigate = useNavigate();

  // Disable user API call
  const handleDisableUser = () => {
    executePatch(() => {}, `${DISABLE_USER}${userID}`);
  };

  return (
    <Modal
      onClose={successResponse || loading ? undefined : closeDialog}
      modalWidth={`${
        successResponse ? "max-w-sm" : "max-w-lg"
      } w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8`}
    >
      <>
        {successResponse ? (
          <div className="text-center">
            <img src={successIcon} alt="success" className="mx-auto w-9 mb-2" />
            <p className="py-5">User Successfully Disabled</p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate("/user/disable-list")}
            />
          </div>
        ) : (
          <>
            {formError && (
              <ErrorDisplay
                message={formError}
                closeAction={() => setFormError("")}
              />
            )}
            <h2 className="text-xl font-figtreeBold mb-4">Disable User</h2>
            <p className="text-gray-700 mb-6">
              Are you sure you want to disable{" "}
              <span className="font-medium text-black">{userName}</span>? <br />
              This action will prevent the user from accessing the system.
            </p>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={closeDialog}
                className="px-4 py-2 rounded-lg border bg-dBlue-100 hover:bg-gray-200 text-dark-blue"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleDisableUser}
                className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
                disabled={loading}
              >
                {loading ? "Disabling..." : "Disable"}
              </button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
}

export default DisableUserDialog;
